module.exports = __webpack_public_path__ + "static/media/enable-user-green.e5d66328.svg";